import { Alert, CircularProgress, Stack, Typography } from '@mui/material';

/**
 * The loading row and the error alert every export section shows while its
 * data is not there yet. Both stay off the printed page: a spinner on paper
 * is nonsense, and the Print button is disabled until the data is in anyway.
 */
export default function QueryState({
  loading,
  loadingLabel,
  error,
}: {
  loading: boolean;
  loadingLabel: string;
  /** Message to show, or '' / undefined for no error. */
  error?: string | null;
}) {
  if (loading) {
    return (
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ py: 2, '@media print': { display: 'none' } }}>
        <CircularProgress size={18} />
        <Typography color="text.secondary">{loadingLabel}</Typography>
      </Stack>
    );
  }
  if (error) {
    return <Alert severity="error" sx={{ '@media print': { display: 'none' } }}>{error}</Alert>;
  }
  return null;
}
